import { CALENDAR_BOOKING_URL } from 'src/utils/constants/config';
import { Box, CircularProgress, Container, styled, Typography, useTheme } from '@mui/material';
import BreadcrumbWithBtnBack from 'src/components/BreadcrumbWithBtnBack';
import React, { useState } from 'react';
const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(7),
}));

const CalendarBooking = () => {
  const theme = useTheme();
  const [isIFrameLoading, setIsIFrameLoading] = useState(true);

  return (
    <StyledContainer maxWidth={'xl'}>
      <BreadcrumbWithBtnBack
        listItem={[
          {
            text: 'Home',
          },
          {
            text: 'Adamftd Demonstration Booking Page',
          },
        ]}
        updatedAt="14-01-2024T00:00:00Z"
        showButtonBack={true}
      />
      <Typography mt={2} variant="h5">
        Book A Guided Help Call With Us
      </Typography>
      <Box mt={3} borderRadius={2}>
      {isIFrameLoading ? <CircularProgress size={20}/> : <></>}
        <iframe
        onLoad={() => setIsIFrameLoading(false)}
          style={{
            width: '100%',
            height: `800px`,
            border: 'none',
            borderRadius: '16px',
            display: isIFrameLoading ? 'none' : 'block'
          }}
          src={CALENDAR_BOOKING_URL}
        />
      </Box>
    </StyledContainer>
  );
};

export default CalendarBooking;
